var markers = [];

function initMapSearch() {

    // Listing app
    const MapSearch = Vue.createApp({
        data() {
            return {
                //defaults
                results: [],
                location: '',
                map: null
            };
        },
        methods: {
            addMarkers: function (searchType) {
                let t = this;
                let qs = null;
                if (searchType === "postcode") {
                    qs = `location=${t.location}`;
                    // validate the postcode field
                    if (!$('#map-search-form').valid()) {
                        return;
                    }
                }
                if (qs !== null) {
                    history.pushState({ location: t.location }, 'Map search', '?' + qs);
                }
                else {
                    // Get QS params
                    const params = new Proxy(new URLSearchParams(window.location.search), {
                        get: (searchParams, prop) => searchParams.get(prop),
                    });
                    const location = params.location;
                    // set values according to QS, if available
                    if (location !== null) {
                        qs = `location=${location}`;
                        t.location = location;
                    }
                    else {
                        t.location = null;
                    }
                }

                // clear existing markers
                t.deleteMarkers();

                // get the data
                $.getJSON(`/umbraco/api/localnetworksapi/getresults?${qs}`, function (data) {
                    t.results = data;
                    const urlParts = [location.protocol, '//', location.host, location.pathname];
                    let url = urlParts.join('');

                    // add the markers
                    for (let i = 0; i < t.results.length; i++) {
                        const m = t.results[i];
                        const latLng = new google.maps.LatLng(m.lat, m.lng);


                        const contentString =
                            '<div class="map-info-window-content">' +
                                '<h3>' + m.name + '</h3>' +
                                '<div class="body-content">' +
                                    //'<p>' + m.postcode + '</p>' +
                                    `<p class="link"><a href="${m.networkUrl}">Visit webpage</a></p>` +
                                '</div>' +
                            '</div>';

                        t.addMarker(latLng, m.name, contentString);
                    }
                    if (qs !== null) {
                        // zoom map to fit results
                        if (t.results.length > 0 && (t.location !== '')) {
                            var bounds = new google.maps.LatLngBounds();
                            for (var i = 0; i < markers.length; i++) {
                                bounds.extend({ lat: markers[i].position.lat(), lng: markers[i].position.lng() });
                            }
                            t.map.fitBounds(bounds);
                        }
                    }
                });
            },
            initMap: function () {
                // initialise the map
                const mapCenter = new google.maps.LatLng(54.783179, -4.6015336);
                const mapOptions = {
                    zoom: 5.8,
                    maxZoom: 12,
                    center: mapCenter,
                    mapTypeId: 'roadmap'
                };
                this.map = new google.maps.Map(document.getElementById("map"), mapOptions);

                // add the markers
                this.addMarkers();
            },

            // Adds a marker to the map and push to the array.
            addMarker: function (position, titleText, labelContent) {
                const t = this;
                const marker = new google.maps.Marker({
                    position: position,
                    map: t.map,
                    icon: '/assets/images/icons/map-pin.svg',
                    title: titleText
                });

                const infowindow = new google.maps.InfoWindow({
                    content: labelContent,
                    //maxWidth: 400,
                });

                marker.addListener("click", () => {
                    infowindow.open({
                        anchor: marker,
                        map,
                        shouldFocus: false,
                    });
                });

                markers.push(marker);
            },

            // Sets the map on all markers in the array.
            setMapOnAll: function (map) {
                for (let i = 0; i < markers.length; i++) {
                    markers[i].setMap(map);
                }
            },

            // Removes the markers from the map, but keeps them in the array.
            hideMarkers: function () {
                this.setMapOnAll(null);
            },

            // Shows any markers currently in the array.
            showMarkers: function () {
                this.setMapOnAll(map);
            },

            // Deletes all markers in the array by removing references to them.
            deleteMarkers: function () {
                this.hideMarkers();
                markers = [];
            },

        },
        created: function () {
            this.initMap();
        }
    });
    const vm = MapSearch.mount('#map-search');

    // back/forward buttons
    $(window).on("popstate", function () {
        vm.addMarkers();
    });
}

setTimeout(function () {
    // feint top & bottom borders when scrolling results
    const debounce = (fn) => {
        let frame;
        return (...params) => {
            if (frame) {
                cancelAnimationFrame(frame);
            }
            frame = requestAnimationFrame(() => {
                fn(...params);
            });
        };
    };

    const storeScroll = () => {
        document.documentElement.dataset.scroll = document.getElementById('search-results').scrollTop;
    };

    document.getElementById('search-results').addEventListener("scroll", debounce(storeScroll), { passive: true });
    storeScroll();
}, 1000);


$.validator.addMethod(
    "regularExpression",
    function (value, element, regexp) {
        var re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
    },
    "Please enter a valid value"
);

$(function () {
    $('#map-search-form').validate({

        rules: {
            postcode: {
                regularExpression: '^[a-zA-Z]{1,2}[0-9]{1,2}[a-zA-Z]?(\\s*[0-9][a-zA-Z]{1,2})?$',
                minlength: 2
            }
        },

        messages: {
            postcode: {
                regularExpression: 'Please enter a valid UK postcode',
                minlength: 'Please enter at least two characters'
            }
        }

    });
});